import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';

const Fixed = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: scroll;
`;

const HeaderMobile = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  border-bottom: 1px solid ${color.gainsboro};
  background: ${color.light};
  z-index: 100;

  &.chat-expanded {
    display: none;
  }

  @media ${device.tablet} {
    display: none;
  }
`;

const HeaderWeb = styled.div`
  display: none;

  width: ${({ isOpen, isMarketOpen }) =>
    (() => {
      if (!isOpen) {
        return 'calc(100% - 48px)';
      }
      if (!isMarketOpen) {
        return 'calc(100% - 438px)';
      }
      return 'calc(100% - 378px)';
    })()};

  &.chat-expanded {
    display: none;
  }

  @media ${device.tablet} {
    position: fixed;
    display: flex;
    justify-content: space-between;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid ${color.gainsboro};
    background: white;
    z-index: 100;
  }
`;

const HeaderWebTop = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 14px;
  height: 60px;
  z-index: 100;
`;

const ProUser = styled(Text).attrs({ as: 'a' })`
  color: ${color.primary};
  border: 1px solid #DADADA;
  padding: 4px 8px;
  border-radius: 3px;
  text-wrap: nowrap;
  white-space: pre;
  margin-right: 16px;
`;

const SwitchButton = styled(Button)`
  &:hover {
    background: ${color.primary};
    p {
      color: ${color.light};
    }
  }
`;

export { Fixed, HeaderMobile, HeaderWeb, HeaderWebTop, ProUser, SwitchButton };
